import { useDispatch, useSelector } from 'react-redux'
import ActivityFeed from './ActivityFeed'
import PropTypes from 'prop-types'
import { getCommunityActivities, getProgramActivities } from '../../../../actions/activityActions'
import { clearCommunityActivities, clearProgramActivities, removeCommunityActivity, removeProgramActivity } from '../../../../reducers/dashboardReducer'
import { useEffect } from 'react'


const GenericFeedComponent = ({ id, type }) => {
  const dispatch = useDispatch()
  const clearActivities = type === 'community' ? clearCommunityActivities : clearProgramActivities
  const activitySelectors = useSelector(state => ({
    feedActivities: type === 'community' ? state.dashboard.communityActivities : state.dashboard.programActivities,
    loadingFeedActivities: type === 'community' ? state.dashboard.loadingCommunityActivities : state.dashboard.loadingProgramActivities,
    activitiesTotalPages: type === 'community' ? state.dashboard.communityActivitiesTotalPages : state.dashboard.programActivitiesTotalPages,
    clearActivities: clearActivities,
    getActivities: type === 'community' ? getCommunityActivities : getProgramActivities,
    removeActivity: type === 'community' ? removeCommunityActivity : removeProgramActivity,
  }))


  useEffect(() => {
    dispatch(clearActivities())
  }, [id, dispatch, clearActivities])

  return <ActivityFeed id={id} {...activitySelectors} isProgram={type === 'program'}/>
}

GenericFeedComponent.propTypes = {
  id: PropTypes.number,
  type: PropTypes.string,
}

export default GenericFeedComponent
